export default __webpack_public_path__ + "static/media/create_enc.4b883473.PNG";